module.exports = __webpack_public_path__ + "static/img/diease-right.ec70c5f5.png";